export default {"src":"/_next/static/media/air_conditioning.0ce781e6.svg","height":100,"width":100};